var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarrito1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18.387,
    height: 18.489,
    viewBox: "0 0 18.387 18.489",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_5",
    "data-name": "Rect\\xE1ngulo 5",
    width: 18.387,
    height: 18.489,
    transform: "translate(0 0)",
    fill: "#1c1c1c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "carrito_1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8",
    "data-name": "Grupo 8",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5",
    "data-name": "Trazado 5",
    d: "M17.926,4a1.749,1.749,0,0,0-1.3-.572H3.831L3.709,1.84A2,2,0,0,0,1.72,0H.75A.751.751,0,0,0,0,.75a.761.761,0,0,0,.75.75h.97a.5.5,0,0,1,.5.461l.94,10.9v0A2.738,2.738,0,0,0,5.9,15.36h9.07a2.739,2.739,0,0,0,2.739-2.5l.67-7.518A1.729,1.729,0,0,0,17.926,4M14.97,13.86H5.9a1.24,1.24,0,0,1-1.241-1.133l-.706-7.8H16.63a.241.241,0,0,1,.185.078.268.268,0,0,1,.066.2l-.67,7.519A1.241,1.241,0,0,1,14.97,13.86",
    fill: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6",
    "data-name": "Trazado 6",
    d: "M7.14,15.989a1.25,1.25,0,1,0,1.25,1.25,1.252,1.252,0,0,0-1.25-1.25",
    fill: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7",
    "data-name": "Trazado 7",
    d: "M13.629,15.989a1.25,1.25,0,1,0,1.25,1.25,1.252,1.252,0,0,0-1.25-1.25",
    fill: "#1c1c1c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarrito1);
export default __webpack_public_path__ + "static/media/carrito_1.b182ee51176e87411516bf111defdb55.svg";
export { ForwardRef as ReactComponent };